import { countryList } from '../app.config';

const useCountries = () => {
  return countryList;
};

export default useCountries;
